import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'Divider',
  props: {
    type: { default: 'horizontal' },
    margin: { default: 0 }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['divider', _ctx.type]),
    style: _normalizeStyle({
      margin: _ctx.type === 'horizontal' ? `${_ctx.margin || 24}px 0` : `0 ${_ctx.margin || 8}px`
    })
  }, null, 6))
}
}

})